// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import entityReducer from './generators/entityReducer'
import * as types from '../actions/action-types'
import * as entityTypes from './generators/entities'

export default entityReducer('conversationMessages', {
  [entityTypes.ENTITIES_FETCH_BEGIN]: types.ADMIN_CONVERSATION_MESSAGES_FETCH_BEGIN,
  [entityTypes.ENTITIES_FETCH_SUCCEEDED]: types.ADMIN_CONVERSATION_MESSAGES_FETCH_SUCCEEDED,
  [entityTypes.ENTITIES_FETCH_FAILED]: types.ADMIN_CONVERSATION_MESSAGES_FETCH_FAILED,
})
